module.exports = __webpack_public_path__ + "images/emoji/o2.66e14ca6f3f5e0e1e57c.png";